export { MiniState } from './state.class';
export { MiniStore } from './store.class';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /deploy/www/v2/sa/app/emr-webapp/~/ngx-bootstrap/mini-ngrx/index.js
// module id = ../../../../ngx-bootstrap/mini-ngrx/index.js
// module chunks = 5